<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  width="1.500em"
  height="1.500em"
  aria-hidden="true"
  focusable="false"
  ><path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4 12l4.9-7h2.2723l-4.20001 6H20l-1 2H6.97229l4.20001 6H8.9L4 12z"
  /></svg
>
